export default __webpack_public_path__ + "static/media/trashIconHover.6909f034.svg";